'use strict';

/**
 * Throttle.
 * @param {Function} func - Callback function
 * @param {number} limit - Timeout.
 * @returns {Function} - Throttler.
 */
function throttle(func, limit) {
    var wait = false;

    return function () {
        if (!wait) {
            func.apply(null, arguments);
            wait = true;
            setTimeout(() => {
                wait = false;
            }, limit);
        }
    };
}

module.exports = throttle;
